/**
 * Creates a password validation object for the given value.
 *
 * @param value - The value to validate.
 * @returns An object with three boolean properties: validLength,
 * includeUppercase, and includeLowercase. Each property indicates whether the
 * corresponding condition is met by the value.
 */
export const createPasswordValidation = (value: string) => {
  /**
   * Checks if the given value has a length of at least 10 characters.
   *
   * @returns A boolean indicating whether the length condition is met.
   */
  const validLength = /.{10,}/.test(value);

  /**
   * Checks if the given value includes at least one uppercase letter.
   *
   * @returns A boolean indicating whether the uppercase condition is met.
   */
  const includeUppercase = /[A-Z]/.test(value);

  /**
   * Checks if the given value includes at least one lowercase letter.
   *
   * @returns A boolean indicating whether the lowercase condition is met.
   */
  const includeLowercase = /[a-z]/.test(value);

  return { validLength, includeUppercase, includeLowercase };
};
